// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__bOpJY","logo":"MainNavigation_logo__gUtut"};